import { snakeToCamel } from '../../../utils/object'

import Model from '../models'

import axios from 'axios'

import EmailTemplateAPI from './api'

export default class EmailTemplate extends Model {
  static api = EmailTemplateAPI.create(EmailTemplate)
  static readOnlyFields = ['id']

  constructor({ id = null, name = '', subject = '', body = '', inactive = false } = {}) {
    super()
    Object.assign(this, {
      id,
      name,
      subject,
      body,
      inactive,
    })
  }

  static create(opts = {}) {
    return new EmailTemplate(opts)
  }

  static fromAPI(json = {}) {
    const data = snakeToCamel(json)
    return new EmailTemplate(data)
  }

  copy() {
    return new EmailTemplate(this)
  }
}
